import React from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Container} from "@pg-design/grid-module";
import {Image} from "@pg-design/image-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";

import {concatWithBrandName} from "../../app/utils/concat_with_brand_name";
import {OfferType} from "../../offer/types/OfferType";
import {useAppDispatch} from "../../store/hooks";
import {openForYouModal} from "../state/for_you_modal_slice";

const consultantImg = require("../images/konsultant.jpg");

export const ForYouConsultantSection = () => {
    const dispatch = useAppDispatch();
    const openModal = () => {
        dispatch(openForYouModal([OfferType.FLAT, OfferType.HOUSE]));
    };
    return (
        <Container as="section" className={sectionStyle}>
            <div className={consultantWrapper}>
                <Image width="160" height="160" alt="Zdjęcie konsultanta" src={consultantImg} className={imageStyle} />
                <div className={css(flexColumnCenterRaw)}>
                    <Text variant="headline_4" as="p" align="center">
                        Maria Kowalska
                    </Text>
                    <Text variant="body_copy_2" align="center" color={getThemeVariable("colors.gray.700")}>
                        {concatWithBrandName("Konsultant")}
                    </Text>
                </div>
            </div>
            <div className={textWrapper}>
                <Text variant="headline_3" align="center">
                    Jestem tutaj, aby pomóc znaleźć Ci Twoje wymarzone M
                </Text>
                <Text variant="body_copy_1" align="center">
                    Powiedz mi, jakiego mieszkania szukasz, a <b>bezpłatnie i szybko znajdę dla Ciebie oferty</b> spełniające Twoje oczekiwania oraz doradzę w
                    wyborze najlepszej! Jeśli potrzebujesz wiedzy o procesie zakupu doradzę Ci z jakich materiałów i źródeł korzystać oraz chętnie odpowiem na
                    nurtujące Ciebie pytania.
                </Text>
            </div>{" "}
            <Button variant="filled_primary" onClick={openModal}>
                Wyszukaj dla mnie
            </Button>
        </Container>
    );
};

const flexColumnCenterRaw = css.raw({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
});

const sectionStyle = css({
    backgroundColor: "var(--colors-background-200)",
    paddingX: 2,
    paddingY: 3,
    ...flexColumnCenterRaw,
    gap: 3,
    borderRadius: 2
});

const consultantWrapper = css({
    ...flexColumnCenterRaw,
    gap: 1,
    paddingY: 1
});

const imageStyle = css({
    borderRadius: "50%"
});

const textWrapper = css({
    ...flexColumnCenterRaw,
    width: "100%",
    gap: 2,

    md: {
        width: "70%"
    }
});
import React from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Container} from "@pg-design/grid-module";
import {Image} from "@pg-design/image-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";

import {concatWithBrandName} from "../../app/utils/concat_with_brand_name";
import {OfferType} from "../../offer/types/OfferType";
import {useAppDispatch} from "../../store/hooks";
import {openForYouModal} from "../state/for_you_modal_slice";

const consultantImg = require("../images/konsultant.jpg");

export const ForYouConsultantSection = () => {
    const dispatch = useAppDispatch();
    const openModal = () => {
        dispatch(openForYouModal([OfferType.FLAT, OfferType.HOUSE]));
    };
    return (
        <Container as="section" className={sectionStyle}>
            <div className={consultantWrapper}>
                <Image width="160" height="160" alt="Zdjęcie konsultanta" src={consultantImg} className={imageStyle} />
                <div className={css(flexColumnCenterRaw)}>
                    <Text variant="headline_4" as="p" align="center">
                        Maria Kowalska
                    </Text>
                    <Text variant="body_copy_2" align="center" color={getThemeVariable("colors.gray.700")}>
                        {concatWithBrandName("Konsultant")}
                    </Text>
                </div>
            </div>
            <div className={textWrapper}>
                <Text variant="headline_3" align="center">
                    Jestem tutaj, aby pomóc znaleźć Ci Twoje wymarzone M
                </Text>
                <Text variant="body_copy_1" align="center">
                    Powiedz mi, jakiego mieszkania szukasz, a <b>bezpłatnie i szybko znajdę dla Ciebie oferty</b> spełniające Twoje oczekiwania oraz doradzę w
                    wyborze najlepszej! Jeśli potrzebujesz wiedzy o procesie zakupu doradzę Ci z jakich materiałów i źródeł korzystać oraz chętnie odpowiem na
                    nurtujące Ciebie pytania.
                </Text>
            </div>{" "}
            <Button variant="filled_primary" onClick={openModal}>
                Wyszukaj dla mnie
            </Button>
        </Container>
    );
};

const flexColumnCenterRaw = css.raw({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
});

const sectionStyle = css({
    backgroundColor: "var(--colors-background-200)",
    paddingX: 2,
    paddingY: 3,
    ...flexColumnCenterRaw,
    gap: 3,
    borderRadius: 2
});

const consultantWrapper = css({
    ...flexColumnCenterRaw,
    gap: 1,
    paddingY: 1
});

const imageStyle = css({
    borderRadius: "50%"
});

const textWrapper = css({
    ...flexColumnCenterRaw,
    width: "100%",
    gap: 2,

    md: {
        width: "70%"
    }
});
